import { Component, Input } from '@angular/core';
import { ColumnViewerService } from 'src/app/api/services/column-viewer.service';
import { TableColumns } from 'src/app/enums/shared.type';

@Component({
  selector: 'app-column-visibility',
  templateUrl: './column-visibility.component.html',
  styleUrls: ['./column-visibility.component.scss']
})
export class ColumnVisibilityComponent {
  @Input() isVisible = false;

  public columns: TableColumns = [];

  constructor(public readonly columnViewerService: ColumnViewerService) {
    this.columnViewerService.allColumns.subscribe(cols => {
      this.columns = cols;
    });
  }

  // updateColumn(event: any, index: number) {
  //   this.tableCols[index].isVisible = event.target.checked;
  // }

  updateColumn(key: string) {
    if (this.columnViewerService.isHiddenColumn(key)) {
      this.columnViewerService.showColumn(key);
    } else {
      this.columnViewerService.hideColumn(key);
    }
  }
}
